export default {
    stickers: {
        title: 'Stickervellen',
        stickerOpacity: 'Sticker dekking',
        stickerColor: 'Stickerkleur',
        shapes: {
            title: 'Vormen',
            rectangle: 'Rechthoek',
            circle: 'Cirkel',
            triangle: 'Driehoek',
        },
        emojis: {
            title: "Emoji's",
        },
    },
};
